import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '[preventScroll]'
})
export class PreventScrollDirective {

  @HostListener("window:scroll", ["$event"])
  public windowScrolled($event: Event) {
    this.windowScrollEvent($event);
    $event.preventDefault();
    $event.stopImmediatePropagation();
  }
  windowScrollEvent(event: any) {
    this.renderer.setStyle(document.body, 'overflow', 'hidden !important')
    this.renderer.setStyle(this.el.nativeElement, 'overflow', 'hidden !important')
  }
  constructor(private el: ElementRef, private renderer: Renderer2) {
  }
}
